// eslint-disable-next-line import/prefer-default-export
export const I18N_DOMAIN_DESIGN_SYSTEM = 'design-system';
